import { Typography } from '@mui/material';
import { useState } from 'react';

import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';

import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { ActionComponentProps } from '../../index';

export const FinishRecycle = ({ mailpieces, actionStarted, onActionFinish }: ActionComponentProps) => {
  const [updatePieces] = useUpdatePiecesMutation();

  const [actionInProgress, setActionInProgress] = useState<boolean>(false);

  const confirmAction = async () => {
    try {
      setActionInProgress(true);

      await updatePieces({
        pieces: mailpieces.map((piece) => ({ id: piece.id })),
        action: PieceAction.FinishRecycle,
      }).unwrap();

      setActionInProgress(false);
      onActionFinish();
    } catch (error) {
      setActionInProgress(false);
    }
  };

  const content =
    mailpieces.length === 1 ? (
      'Please recycle this item, and click Complete when you’re done.'
    ) : (
      <Typography variant="body1" color="text.secondary">
        Please recycle <strong>{mailpieces.length}</strong> item(s), and click Complete when you’re done.
      </Typography>
    );

  return (
    <DialogConfirmation
      open={actionStarted}
      loading={actionInProgress}
      maxWidth="xs"
      title={mailpieces.length === 1 ? 'Recycle item' : 'Recycle selected items'}
      content={content}
      acceptButtonHandleClick={confirmAction}
      cancelButtonHandleClick={onActionFinish}
      acceptButtonTitle="Complete"
      cancelButtonTitle="Cancel"
    />
  );
};
